import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getRandomImage } from "../../../../../utils/config";

export default function SubTarjetaCategoria({
  nombreCategoria = "",
  vCategoriasId,
}) {
  const vNavigate = useNavigate();
  const [vImgUrl, setvImgUrl] = useState(getRandomImage());

  

  return (
    <div
      data-figma-id="121:8936"
      class="tarjeta-explora"
      style={{
        backgroundImage: `url(${vImgUrl})`,
      }}
      key={vCategoriasId}
      onClick={() =>
        vNavigate(
          vCategoriasId
            ? `/cursos?page=1&page_size=10&categoria_ids=${vCategoriasId}`
            : `/cursos?page=1&page_size=10`
        )
      }
    >
      <div data-figma-id="121:8937" class="trending-info">
        <p data-figma-id="121:8938" class="trending-info-texto-1">
          Explorar los cursos{" "}
        </p>
        <p data-figma-id="121:8939" class="trending-info-texto-2">
          {nombreCategoria}
        </p>
      </div>
    </div>
  );
}
